import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Tag } from 'antd';
import { Enumify } from 'enumify-ts';
class AddressStatusType extends Enumify() {
    description;
    colour;
    static INVALID = new AddressStatusType("INVALID", "red");
    static VALIDATED = new AddressStatusType("VALIDATED", "green");
    static _ = AddressStatusType._closeEnum();
    constructor(description, colour) {
        super();
        this.description = description;
        this.colour = colour;
    }
    renderTag() {
        return _jsx(Tag, { color: this.colour, children: this.description });
    }
}
export default AddressStatusType;
